import {
  FinanceType,
  ProductTemplateType,
  ProductVatType,
  TaxTypeId,
  TransactionType,
  WhtAmountType,
} from "@/enums/enums";
import peakUtility from "./peakUtility";
import { GetWhtAmountValue } from "./shareHelper";

const vatPercent = 7;

function GetTransactionItemList(_transaction: any) {
  const transactionItemList = [];
  if (_transaction.transactionItemList.length > 0) {
    let total = 0;
    let totalForCalculateTransactionDiscount = 0;
    let sameProductVatTypeId = 0;
    let isServiceOnly = false;
    let isHaveProduct = false;
    let dummyProductVatTypeId = 0;
    let countProductWithoutDescriptionOnly = 0;
    for (let sequenceNumber = 0; sequenceNumber < _transaction.transactionItemList.length; sequenceNumber++) {
      const _transactionItem = _transaction.transactionItemList[sequenceNumber];
      const isDescriptionOnly = _transactionItem.isDescriptionOnly;
      let accountId = 0;
      let transactionItemPrice = 0;
      let transactionItemAmount = 0;
      let transactionItemDiscount = 0;
      let transactionItemDiscountTypeId = 0;
      let transactionItemVatTypeId = 0;
      let transactionItemWhtAmountTypeId = -2;
      let transactionItemWhtAmount: any = 0;
      let productTemplateId = 0;
      const transactionItemDescription = _transactionItem.description;
      let fixedAssetTemplateId = 0;
      let transactionItemTotal = 0;
      let transactionItemTypeId = 2;
      let taxIncomeTypeId = 0;
      let transactionItemPreVatAmount = 0;
      let transactionItemVatAmount = 0;
      if (!isDescriptionOnly) {
        countProductWithoutDescriptionOnly++;
        accountId = _transactionItem.account.id.ToNumber();
        transactionItemPrice = _transactionItem.price.value.ToNumber();
        transactionItemAmount = _transactionItem.amount.value.ToNumber();
        taxIncomeTypeId = _transactionItem.account.taxIncomeTypeId.ToNumber();
        const discountValue = _transactionItem.discount.value;
        if (_transactionItem.discount.discountTypeId == 1) {
          transactionItemDiscount = discountValue.ToNumber();
          transactionItemDiscountTypeId = 1;
        } else {
          transactionItemDiscount = discountValue.ToNumber();
          transactionItemDiscountTypeId = 0;
        }
        if (_transaction.taxStatus.value == TaxTypeId.None) {
          _transactionItem.vatTypeId.value = ProductVatType.None;
        }
        transactionItemVatTypeId = _transactionItem.vatTypeId.value;
        if (countProductWithoutDescriptionOnly === 1) {
          dummyProductVatTypeId = transactionItemVatTypeId;
          sameProductVatTypeId = transactionItemVatTypeId;
        }
        if (dummyProductVatTypeId !== transactionItemVatTypeId) {
          sameProductVatTypeId = 0;
        }
        productTemplateId = _transactionItem.productTemplate.id;
        fixedAssetTemplateId = _transactionItem.fixedAssetTemplate.id;
        if (productTemplateId > 0) {
          transactionItemTypeId = _transactionItem.productTemplate.productTypeId;
        } else if (fixedAssetTemplateId > 0) {
          transactionItemTypeId = _transactionItem.fixedAssetTemplate.fixedAssetTypeId;
        }
        if (productTemplateId > 0 || fixedAssetTemplateId > 0) {
          if (transactionItemTypeId == ProductTemplateType.Product) {
            isHaveProduct = true;
          }

          if (transactionItemTypeId == ProductTemplateType.Service && !isHaveProduct) {
            isServiceOnly = true;
          } else {
            isServiceOnly = false;
          }
        }
        let transactionItemPriceTotal = 0;
        if (transactionItemDiscountTypeId === 1) {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
            transactionItemPrice,
            peakUtility.PeakOperatorDivide(
              peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
              100
            )
          );
        } else {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
        }
        transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);
        total = peakUtility.PeakOperatorAdd(total, transactionItemTotal);
        totalForCalculateTransactionDiscount = peakUtility.PeakOperatorAdd(
          totalForCalculateTransactionDiscount,
          transactionItemTotal > 0 ? transactionItemTotal : 0
        );
        if (_transaction.taxStatus.value === TaxTypeId.IncludeTax) {
          if (_transactionItem.vatTypeId.value === ProductVatType.SevenPercent) {
            transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
              peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
              100
            );
            transactionItemVatAmount = peakUtility.PeakOperatorSubtract(
              transactionItemTotal,
              transactionItemPreVatAmount
            );
          } else {
            transactionItemPreVatAmount = transactionItemTotal;
          }
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
          if (_transactionItem.vatTypeId.value === ProductVatType.SevenPercent) {
            transactionItemVatAmount = peakUtility.PeakOperatorMultiply(
              transactionItemTotal,
              peakUtility.PeakOperatorDivide(7, 100)
            );
          }
        }
        transactionItemWhtAmountTypeId = _transactionItem.itemWht.whtAmountType;
        _transactionItem.itemWht.percent = GetWhtAmountValue(transactionItemWhtAmountTypeId);
        if (transactionItemWhtAmountTypeId === WhtAmountType.NotSpecify) {
          transactionItemWhtAmount = null;
          _transactionItem.itemWht.value = null;
        } else if (transactionItemWhtAmountTypeId === WhtAmountType.None) {
          transactionItemWhtAmount = 0;
          _transactionItem.itemWht.value = 0;
        } else if (transactionItemWhtAmountTypeId === WhtAmountType.Custom) {
          transactionItemWhtAmount = _transactionItem.itemWht.value;
        } else {
          _transactionItem.itemWht.value = peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemPreVatAmount, _transactionItem.itemWht.percent),
            100
          );
          transactionItemWhtAmount = _transactionItem.itemWht.value;
        }
        _transactionItem.itemPreVatTotal = transactionItemPreVatAmount.FormatMoney();
        _transactionItem.itemVatTotal = transactionItemVatAmount.FormatMoney();
        _transactionItem.itemNetTotal = peakUtility
          .PeakOperatorAdd(transactionItemPreVatAmount, transactionItemVatAmount)
          .FormatMoney();
      }
      const transactionItem = {
        transactionItemTotal: transactionItemTotal,
        price: transactionItemPrice,
        amount: transactionItemAmount,
        accountid: accountId,
        discount: transactionItemDiscount,
        discountType: transactionItemDiscountTypeId,
        vatTypeId: transactionItemVatTypeId,
        whtAmountTypeId: transactionItemWhtAmountTypeId,
        whtAmount: transactionItemWhtAmount,
        productTemplateId: productTemplateId,
        fixAssetTemplateId: fixedAssetTemplateId,
        description: transactionItemDescription,
        sequenceNumber: sequenceNumber + 1,
        isDescriptionOnly: isDescriptionOnly,
        transactionItemTypeId: transactionItemTypeId,
        taxIncomeTypeId: taxIncomeTypeId,
        preVatAmount: transactionItemPreVatAmount,
        vatAmount: transactionItemVatAmount,
      };
      transactionItemList.push(transactionItem);
    }

    return {
      transactionItemList: transactionItemList,
      total: total,
      sameProductVatTypeId: sameProductVatTypeId,
      isServiceOnly: isServiceOnly,
      totalForCalculateTransactionDiscount: totalForCalculateTransactionDiscount,
    };
  }
}

export function DoGetTransactionItemList(_transaction: any) {
  return GetTransactionItemList(_transaction);
}

function GetTransactionItemSummary(_transaction: any) {
  let vatExemptedTotal = 0;
  let zeroVatTotal = 0;
  let sevenVatTotal = 0;
  let whtTotal = 0;

  const transactionItemModel: any = GetTransactionItemList(_transaction);
  const isOnlyNoneOrNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem: any) => transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0
    ).length > 0
      ? false
      : true;
  const isHaveSomeNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem: any) => transactionItem.whtAmountTypeId === WhtAmountType.NotSpecify
    ).length > 0;
  const isNoneOrNotSpecifyWht = isHaveSomeNotSpecifyWht && isOnlyNoneOrNotSpecifyWht;
  let subTotalForCalculate = 0;
  for (const transactionItem of transactionItemModel.transactionItemList) {
    let discountTransactionPerProduct = 0;
    if (transactionItem.transactionItemTotal > 0) {
      if (_transaction.transactionDiscount.discountType === 1) {
        discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(_transaction.transactionDiscount.value, 100),
          transactionItem.transactionItemTotal
        );
      } else {
        discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(
            transactionItem.transactionItemTotal,
            transactionItemModel.totalForCalculateTransactionDiscount
          ),
          _transaction.transactionDiscount.value
        );
      }
    }
    //Depend on taxStatus
    const transactionItemTotalWithDiscount = peakUtility.PeakOperatorSubtract(
      transactionItem.transactionItemTotal,
      discountTransactionPerProduct
    );
    const transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
      transactionItem.preVatAmount,
      discountTransactionPerProduct
    );

    let whtTransactionItemWithDiscount = 0;
    if (transactionItem.whtAmount != null && transactionItem.transactionItemTotal != 0) {
      whtTransactionItemWithDiscount = peakUtility.PeakOperatorMultiply(
        transactionItem.whtAmount,
        peakUtility.PeakOperatorDivide(transactionItemTotalWithDiscount, transactionItem.transactionItemTotal)
      );
    }
    whtTotal = peakUtility.PeakOperatorAdd(whtTransactionItemWithDiscount, whtTotal);
    if (isNoneOrNotSpecifyWht && transactionItem.whtAmountTypeId === WhtAmountType.NotSpecify) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(subTotalForCalculate, transactionItemPreVatTotalWithDiscount);
    } else if (!isNoneOrNotSpecifyWht && (transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0)) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(subTotalForCalculate, transactionItemPreVatTotalWithDiscount);
    }

    switch (transactionItem.vatTypeId.ToNumber()) {
      case 3:
        sevenVatTotal = peakUtility.PeakOperatorAdd(sevenVatTotal, transactionItemTotalWithDiscount);
        break;
      case 2:
        zeroVatTotal = peakUtility.PeakOperatorAdd(zeroVatTotal, transactionItemTotalWithDiscount);
        break;
      default:
        vatExemptedTotal = peakUtility.PeakOperatorAdd(vatExemptedTotal, transactionItemTotalWithDiscount);
        break;
    }
  }
  const total = peakUtility.PeakOperatorAdd(peakUtility.PeakOperatorAdd(vatExemptedTotal, zeroVatTotal), sevenVatTotal);
  return {
    vatExemptedTotal: vatExemptedTotal,
    zeroVatTotal: zeroVatTotal,
    sevenVatTotal: sevenVatTotal,
    total: total,
    subTotalForCalculate: subTotalForCalculate,
    whtTotal: whtTotal,
    isNoneOrNotSpecifyWht: isNoneOrNotSpecifyWht,
    isServiceOnly: transactionItemModel.isServiceOnly,
    sameProductVatTypeId: transactionItemModel.sameProductVatTypeId,
  };
}

export function DoGetTransactionItemSummary(_transaction: any) {
  return GetTransactionItemSummary(_transaction);
}

function RemoveTransactionItemEmpty(_transaction: any, triggerAlert: any) {
  if (triggerAlert && _transaction.transactionItemList && _transaction.transactionItemList.length > 1) {
    const transactionItemList = _transaction.transactionItemList.filter((transactionItem: any) => {
      if (
        !(
          (!transactionItem.isDescriptionOnly &&
            transactionItem.account.id == 0 &&
            transactionItem.description.text == "" &&
            transactionItem.price.value.ToNumber() == 0 &&
            transactionItem.discount.value.ToNumber() == 0) ||
          (transactionItem.isDescriptionOnly && transactionItem.description.text == "")
        )
      ) {
        return transactionItem;
      }
    });

    if (transactionItemList && transactionItemList.length > 0) {
      _transaction.transactionItemList = transactionItemList;
    }
  }
}

export function TransactionValidationAndRemoveTransactionItemEmpty(
  transaction: any,
  triggerAlert = true,
  isImportTransaction = false
) {
  let numberValidateError = false;
  if (isImportTransaction) {
    numberValidateError = transaction.number.validateError;
  } else {
    numberValidateError = transaction.number.value === "" || transaction.number.validateError;
  }

  const referenceValidateError = transaction.reference.validateError;
  let transactionListValidateError = false;
  let contactValidateError = false;
  const dateValidateError = !transaction.date.value || transaction.date.validateError;
  let dueDateValidateError = false;
  const netAmountValidateError = transaction.transactionSummary.netAmount.ToNumber() < 0 ? true : false;
  let paymentValidateError = false;
  const remarkValidateError = transaction.remark ? transaction.remark.validateError : false;
  const purchaseTaxInvoiceValidateError = false;
  let transactionCurrencySummaryVatIsActive = false;
  const receivedTaxInvoiceValidateError = transaction.receivedTaxInvoice
    ? transaction.receivedTaxInvoice.validateError
    : false;
  if (
    transaction.transactionType !== TransactionType.TaxInvoice &&
    !(
      transaction.transactionType === TransactionType.Receipt &&
      (transaction.reference.referenceTypeId === TransactionType.Invoice ||
        transaction.reference.referenceTypeId === TransactionType.BillingNote)
    )
  ) {
    transactionListValidateError = transaction.isValidateError;
    contactValidateError = transaction.contact.validateError || transaction.contact.id === 0;
    if (transaction.transactionCurrencySummary.vat) {
      transactionCurrencySummaryVatIsActive = transaction.transactionCurrencySummary.vat.isActive;
    }
  }
  if (
    !(
      transaction.transactionType === TransactionType.Receipt &&
      (transaction.reference.referenceTypeId === TransactionType.Invoice ||
        transaction.reference.referenceTypeId === TransactionType.BillingNote) &&
      transaction.reference.paymentGroupId !== 0
    )
  ) {
    paymentValidateError = transaction.payment ? transaction.payment.isValidateError : false;
  }
  if (
    transaction.transactionType === TransactionType.Invoice ||
    (transaction.transactionType === TransactionType.Quotation && transaction.financeType === FinanceType.InFlow)
  ) {
    dueDateValidateError = !transaction.dueDate.value || transaction.dueDate.validateError;
  }
  let returnTransactionValidateError = true;
  if (
    !numberValidateError &&
    !referenceValidateError &&
    !transactionListValidateError &&
    !contactValidateError &&
    !netAmountValidateError &&
    !paymentValidateError &&
    !purchaseTaxInvoiceValidateError &&
    !dateValidateError &&
    !dueDateValidateError &&
    !transactionCurrencySummaryVatIsActive &&
    !remarkValidateError &&
    !receivedTaxInvoiceValidateError
  ) {
    returnTransactionValidateError = false;
  } else if (triggerAlert) {
    transaction.contact.validateError = contactValidateError;
    transaction.date.validateError = dateValidateError;
    transaction.number.validateError = numberValidateError;
    transaction.transactionItemList.forEach((transactionItem: any) => {
      if (transactionItem.description.text === "") {
        transactionItem.description.validateError = true;
      }
      if (transactionItem.productTemplate.id == 0) {
        transactionItem.productTemplate.validateError = true;
      }
    });
  }

  if (!returnTransactionValidateError) {
    RemoveTransactionItemEmpty(transaction, triggerAlert);
  }

  return returnTransactionValidateError;
}

export function ToCreateBookmark(_input: any, summary: any) {
  const transactionTemplateProductModel = [];
  if (_input.transaction.transactionItemList) {
    for (const transactionItem of _input.transaction.transactionItemList) {
      const _transactionItem = {
        transactionId: 0,
        description: transactionItem.description.text,
        price: _input.isRememberAmountAndPrice == 1 ? transactionItem.price.value.ToNumber() : 0,
        amount: _input.isRememberAmountAndPrice == 1 ? transactionItem.amount.value.ToNumber() : 1,
        discount: transactionItem.discount.value.ToNumber(),
        vatTypeId: transactionItem.vatTypeId.value,
        productTemplateId: transactionItem.productTemplate.id == 0 ? null : transactionItem.productTemplate.id,
        productTemplateCode: transactionItem.productTemplate.code,
        discountType: 0,
        netAmount: transactionItem.itemPreVatTotal.ToNumber(),
        accountId: transactionItem.account.id,
        accountCode: transactionItem.account.code,
        isDescriptionOnly: transactionItem.isDescriptionOnly,
        whtAmount: transactionItem.itemWht.value,
        whtAmountType: transactionItem.itemWht.whtAmountType,
        sequenceNumber: 0,
      };
      transactionTemplateProductModel.push(_transactionItem);
    }
  }
  const transactionCreate = {
    id: 0,
    name: _input.name,
    isRememberContact: _input.isRememberContact,
    isRememberAmountAndPrice: _input.isRememberAmountAndPrice,
    description: _input.description,
    transactionType: _input.transaction.transactionType,
    financeType: _input.transaction.financeType,
    transactionTemplateModel: {
      id: 0,
      expenseType: _input.transaction.expenseType,
      taxStatus: _input.transaction.taxStatus.value,
      status: 0,
      remark: _input.transaction.remark.text,
      discount: _input.transaction.transactionDiscount.value.ToNumber(),
      discountType: _input.transaction.transactionDiscount.discountType,
      subTotal:
        _input.transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        _input.transaction.transactionSummary.vatExemptedTotal.ToNumber() +
        _input.transaction.transactionSummary.zeroVatTotal.ToNumber(),
      netAmount: _input.transaction.transactionSummary.netAmount.ToNumber(),
      whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
      vatExemptedTotal: _input.transaction.transactionSummary.vatExemptedTotal.ToNumber(),
      zeroVatTotal: _input.transaction.transactionSummary.zeroVatTotal.ToNumber(),
      preVatTotal: _input.transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: _input.transaction.transactionSummary.vat.vatTotal.ToNumber(),
      subTotalForCalculateWht: _input.transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
      isCreateTaxInvoice: _input.transaction.issueTaxInvoice.value ? 1 : 0,
      isAllNoneOrNotSpecifyWht: _input.transaction.transactionSummary.isNoneOrNotSpecifyWht,
      isServiceOnly: _input.transaction.transactionSummary.isServiceOnly,
      sameProductVatTypeId: _input.transaction.transactionSummary.sameProductVatType,
      currencyNetAmount: _input.transaction.transactionCurrencySummary.netAmount.ToNumber(),
      currencyZeroVatTotal: _input.transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
      currencyPreVatTotal: _input.transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
      currencyVatTotal: _input.transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
      currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
      currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
      currencyExchangeRates: _input.transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
      currencyRatio: _input.transaction.transactionCurrencySummary.ratio.ToNumber(),
      currencyVatExemptedTotal: _input.transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
      fromCurrencyUid: _input.transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
      toCurrencyUid: _input.transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
      // contactId: setBookmark.isRememberContact == 1 ? transaction.contact.id : 0,
      contactId: _input.transaction.contact.id,
    },
    transactionTemplateProductModel: transactionTemplateProductModel,
  };

  return transactionCreate;
}

export function GetTransactionSummary(_transaction: any) {
  const taxStatus = _transaction.taxStatus.value;
  const currencyRatio = _transaction.transactionCurrencySummary.ratio;
  const currencyExchangeRates = _transaction.transactionCurrencySummary.exchangeRate;
  const transactionItemSummaryModel = GetTransactionItemSummary(_transaction);
  const transactionWht = {
    subTotalForCalculate: transactionItemSummaryModel.subTotalForCalculate,
    whtTotal: transactionItemSummaryModel.whtTotal,
    isServiceOnly: transactionItemSummaryModel.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionItemSummaryModel.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionItemSummaryModel.sameProductVatTypeId,
  };
  const vatExemptedTotal: any = peakUtility
    .PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.vatExemptedTotal, currencyExchangeRates),
      currencyRatio
    )
    .ToAccountingRoundUp();
  const zeroVatTotal: any = peakUtility
    .PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.zeroVatTotal, currencyExchangeRates),
      currencyRatio
    )
    .ToAccountingRoundUp();
  const currencyVatExemptedTotal: any = transactionItemSummaryModel.vatExemptedTotal.ToAccountingRoundUp();
  const currencyZeroVatTotal: any = transactionItemSummaryModel.zeroVatTotal.ToAccountingRoundUp();
  let preVatTotal: any = 0;
  let vat: any = 0;
  let netAmount: any = 0;
  let currencyPreVatTotal: any = 0;
  let currencyVatTotal: any = 0;
  let currencyNetAmount: any = 0;
  if (taxStatus.ToNumber() === TaxTypeId.ExcludeTax) {
    vat = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, currencyExchangeRates),
            currencyRatio
          ),
          vatPercent
        ),
        100
      )
      .ToAccountingRoundUp();
    preVatTotal = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUp();
    netAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            preVatTotal.ToAccountingRoundUpNumber(),
            zeroVatTotal.ToAccountingRoundUpNumber()
          ),
          vatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        vat.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUp();

    currencyVatTotal = peakUtility
      .PeakOperatorDivide(peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, vatPercent), 100)
      .ToAccountingRoundUp();
    currencyPreVatTotal = transactionItemSummaryModel.sevenVatTotal.ToAccountingRoundUp();
    currencyNetAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            currencyPreVatTotal.ToAccountingRoundUpNumber(),
            currencyZeroVatTotal.ToAccountingRoundUpNumber()
          ),
          currencyVatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        currencyVatTotal.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUp();
  } else {
    netAmount = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.total, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUp();
    const totalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(netAmount, zeroVatTotal),
      vatExemptedTotal
    );
    vat = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(totalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUp();
    preVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(peakUtility.PeakOperatorSubtract(netAmount, vat), zeroVatTotal),
        vatExemptedTotal
      )
      .ToAccountingRoundUp();

    currencyNetAmount = transactionItemSummaryModel.total.ToAccountingRoundUp();
    const currencyTotalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyZeroVatTotal),
      currencyVatExemptedTotal
    );
    currencyVatTotal = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(currencyTotalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUp();
    currencyPreVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(
          peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyVatTotal),
          currencyZeroVatTotal
        ),
        currencyVatExemptedTotal
      )
      .ToAccountingRoundUp();
  }
  const transactionSummary = {
    netAmount: netAmount,
    vatTotal: vat,
    preVatTotal: preVatTotal,
    zeroVatTotal: zeroVatTotal,
    vatExemptedTotal: vatExemptedTotal,
    whtTotal: peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionWht.whtTotal, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionWht.subTotalForCalculate, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUpNumber(),
    isServiceOnly: transactionWht.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionWht.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionWht.sameProductVatTypeId.ToNumber(),
  };
  const transactionCurrencySummary = {
    netAmount: currencyNetAmount,
    vatTotal: currencyVatTotal,
    preVatTotal: currencyPreVatTotal,
    zeroVatTotal: currencyZeroVatTotal,
    vatExemptedTotal: currencyVatExemptedTotal,
    whtTotal: transactionWht.whtTotal.ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: transactionWht.subTotalForCalculate.ToAccountingRoundUpNumber(),
  };
  return { transactionSummary: transactionSummary, transactionCurrencySummary: transactionCurrencySummary };
}

export function SuggestionDescription(newDescription: string, oldDescription: string, allDescription: string) {
  let suggestionDescription = "";
  newDescription = newDescription ? newDescription.trim() : "";
  oldDescription = oldDescription ? oldDescription.trim() : "";
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    suggestionDescription = newDescription;
  } else if (newDescription) {
    if (oldDescription) {
      const oldDescriptionForSearch = oldDescription == allDescription ? oldDescription : oldDescription + " ";
      const indexOfFirst = allDescription.indexOf(oldDescriptionForSearch);
      if (indexOfFirst == 0) {
        const oldDescriptionLength = oldDescription.length;
        allDescription = allDescription.substring(oldDescriptionLength).trim();
      }
    }
    suggestionDescription = newDescription + " " + allDescription;
  } else {
    suggestionDescription = allDescription;
  }
  return suggestionDescription;
}

export function RemoveTextInDescription(text: string, allDescription: string) {
  let description = "";
  text = text ? text.trim() : "";
  allDescription = allDescription ? allDescription.trim() : "";
  if (!allDescription) {
    description = "";
  } else if (text) {
    const textForSearch = text == allDescription ? text : text + " ";
    const indexOfFirst = allDescription.indexOf(textForSearch);
    if (indexOfFirst == 0) {
      const textLength = text.length;
      allDescription = allDescription.substring(textLength).trim();
    }
    description = allDescription;
  } else {
    description = allDescription;
  }
  return description;
}
